export default {
  backendApi: "https://api.keycma.com/",
};
